import VueRouter from 'vue-router'
import store from './store'

const routes = [
    { path: '/', component: require('@/account/Account').default },
    { path: '/names', component: require('@/account/Names').default },
    { path: '/gdpr-invites', component: require('@/account/GDPRInvites').default },
    { path: '/download', component: require('@/account/Download').default },
    { path: '/groups', component: require('@/account/Groups').default },
    { path: '/team', component: require('@/account/Team').default },
    { path: '/download-direct', component: require('@/account/Download').default, name: 'download-direct' },
    { path: '/register-gdpr', component: require('@/account/RegisterGDPR').default, name: 'register-gdpr'},
    { path: '/register-cs', component: require('@/account/Register').default, name: 'register-cs'},
    { path: '/register', redirect: { name: 'register-gdpr' } }
]

const router = new VueRouter({
    // root: '/account',
    // mode: 'history',
    routes
})

router.afterEach((to, from) => {
    // Clear any errors in the state
    const newPageInfo = Object.assign({}, store.state.pageInfo)
    newPageInfo.error = ''
    store.commit('updatePageInfo', newPageInfo)
})

export default router



// WEBPACK FOOTER //
// ./apps/account/router.js